import type { TFunction } from 'i18next';

export type TProtectedResourceType =
  | 'device'
  | 'document'
  | 'gateway'
  | 'group'
  | 'integration'
  | 'license'
  | 'pipeline'
  | 'project'
  | 'resourcegroup'
  | 'secret'
  | 'vault'
  | 'webhook';

export const getProtectedResourceLabel = (
  t: TFunction,
  resourceType: TProtectedResourceType,
): string => {
  return t('common:protected_resource', {
    resource: t(`common:resource_type.${resourceType}`),
  });
};
